import { skipToken } from '@reduxjs/toolkit/query'
import { PropsWithChildren } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from '../auth/UseAuth'
import { useGetTenantQuery } from '../redux/api/customersApi'
import  { NotFound } from './common/NotFound/NotFound'
import { HomeComponent } from './Home/HomeComponet'
import { Orders } from './Orders/Orders'
import RegistrationComponent from './Registration/RegistrationComponent'
import { ResultsComponent } from './Results/ResultsComponent'
import { OrderUpload } from './Upload/OrderUpload'
import { WelcomeComponent } from './Welcome/WelcomeComponent'
import ViewCsv from './WorkItems/CSV/ViewCsv'
import { WorkItems } from './WorkItems/WorkItemsComponent'
import { WorkflowOrderKind } from '@ail/orders-api'

interface PrivateRouteProps extends PropsWithChildren {
  permission?: string,
  tags?: string[],
  notTags?: string[]
}

function Private(props: PrivateRouteProps) {
  const { user } = useAuth()
  const tenant = useGetTenantQuery(user?.tenant ?? skipToken)
  if (user === undefined) {
    return null
  }

  if (user?.tenant && !tenant.data && !tenant.error) {
    return null
  }

  if (user?.isAdmin || user?.isInternalUser) {
    return props.children
  }

  const hasPermission = !props.permission || user?.permissions?.some(p => p === props.permission);
  const hasTags = !props.tags || props.tags.every(t => tenant.data?.tags.some(tt => t.toLowerCase() === tt.toLowerCase()));
  const hasNotTags = !props.notTags || !props.notTags.some(t => tenant.data?.tags.some(tt => t.toLowerCase() === tt.toLowerCase()));
  
  if (hasPermission && hasTags && hasNotTags) {
    return props.children
  }
  
  return  <Navigate to="/"/>
}

function AllRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomeComponent/>} />
      <Route path="/incoming" element={<Private permission={'incoming.view'} tags={['interfleetpro']}><Orders key={'Incoming'} kind={WorkflowOrderKind.Incoming}/></Private>}>
        <Route path=":orderId/details" element />
        <Route path=":requestId/request" element />
      </Route>
      <Route path="/outgoing" element={<Private permission={'outgoing.view'} tags={['interfleetpro']}><Orders key={'Outgoing'} kind={WorkflowOrderKind.Outgoing}/></Private>}>
        <Route path=":orderId/details" element />
        <Route path=":requestId/request" element />
      </Route>
      <Route path="/welcome/:vin" element={<WelcomeComponent/>} />
      <Route path="/registration" element={<RegistrationComponent/>} />
      <Route path="/results/:id" element={<ResultsComponent />} />
      <Route path="/search/:vin" element={<ResultsComponent />} />
      <Route path="/upload" element={<Private permission={'outgoing.view'} tags={['vehicleproductionupload']}><OrderUpload key="upload"/></Private>} />
      <Route path="/WorkItems" element={<Private permission={'workitems.view'} notTags={['interfleetpro']}><WorkItems/></Private>}>
        <Route path=":requestId/details" element={<ViewCsv />} />
      </Route>
      <Route path="/index.html" element={<Navigate to="/" replace/>}/>
      <Route path="*" element={<NotFound/>} />
    </Routes>
  )
}

export default AllRoutes
